$(function () {
	commentsLoader()
	setBlocks()
	imageComment()
})

function commentsLoader() {
	const $allContent = $('[data-ajax-container]');
	const $allTags = $("[data-pagination]");
	const $newComments = $(".ArtComments__New");
	const location = document.location.href;
	const $doneMessage = $(".ArtComments__DoneMessage");
	
	function doneMessage() {
		if(location.includes("comment=")) {
			$doneMessage.fadeIn();
		}
	}
	
	function getContent(url, func) {
		$.ajax({
			method: 'GET',
			url: url,
			header: {'Content-Type': 'application/json'}
		}).done(func)
	}
	
	$(document).on('click',"[data-pagination]", function (e) {
		e.preventDefault()
		
		if (!$(this).hasClass('disabled')) {
			const link = $(this).attr('href');
			
			getContent(`${link}`, function (response) {
				$allContent.html($(response).find("[data-ajax-container]").children())
				
				var newurl = window.location.protocol + '//' + window.location.host + link;
				window.history.replaceState({ path: newurl }, '', newurl);
				window.history.pushState({ path: newurl }, '', newurl);
				AOS.refresh();
			})
		}
	})
	
	$(document).on('click', ".ArtComments__OpenForm", function (e) {
		$newComments.slideToggle()
	})
	
	doneMessage()
}

function setBlocks() {
	function replaceRecipe() {
		const $recipeLink = $('p:contains("[[metafields-recipe]]")');
		const $recipeBlock = $('.ArticleRecipe');

		$recipeLink.replaceWith($recipeBlock)
	}
	
	function replaceIWT() {
		const $iwtLinks = $('p:contains("[[metafields-iwt]]")');
		const $iwtBlocks = $('.ArticleIWT');
		
		$iwtLinks.each(function( index ) {
			if  ($iwtBlocks[index]) {
				this.replaceWith($iwtBlocks[index])
			} else {
				$(this).detach()
			}
		})
		
	}
	
	function replaceGallery() {
		const $galleryLinks = $('p:contains("[[metafields-gallery]]")');
		const $galleryBlocks = $('.ArticleGallery');
		
		$galleryLinks.each(function( index ) {
			if  ($galleryBlocks[index]) {
				this.replaceWith($galleryBlocks[index])
			} else {
				$(this).detach()
			}
		})
		
	}
	
	replaceGallery()
	replaceRecipe()
	replaceIWT()
}

function imageComment() {
	const $imageComments = $('p:contains("[[image-comment]]")');
	
	$imageComments.each(function( index ) {
		let textReplace = $(this).html().replace("[[image-comment]]", "");
		
		$(this).html(textReplace).addClass("ImageDescription");
	})
}